/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentExecutionBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmDocumentExecutionBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentExecutionBatchResponse>): AwsSsmDocumentExecutionBatchResponse {
        let obj = Object.assign(new AwsSsmDocumentExecutionBatchResponse(), model);
        AwsSsmDocumentExecutionBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentExecutionBatchResponse>): AwsSsmDocumentExecutionBatchResponse {
        if (!model) return null;
        return AwsSsmDocumentExecutionBatchResponse.newInstance(<AwsSsmDocumentExecutionBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentExecutionBatchResponse) {
        if (!obj) return;

        models.AwsSsmDocumentExecutionBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentExecutionBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentExecutionBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmJob.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmJob; };

}
